import React , { Component }from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';
import './assets/dist/css/bootstrap.css';
import './assets/css/style.css';
import './assets/css/rfs.css';
import * as myConstClass from './constant.js';
import { Editor} from 'react-draft-wysiwyg';
import { EditorState,convertToRaw,convertFromRaw  } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {stateToHTML} from 'draft-js-export-html'; 
import NewHeader from './newHeader.js';
import Footer from './Footer.js';
import $ from 'jquery';
import SimpleReactValidator from 'simple-react-validator';

// Translation Higher Order Component
import {
    setTranslations,
    setDefaultLanguage,
    setLanguageCookie,
    setLanguage,getLanguage,
    translate,
  } from 'react-switch-lang';
import en from './en.json';
import ma from './ma.json';
import PropTypes from 'prop-types';
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row
  } from 'reactstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
class Resetpassword extends Component {
    constructor(props) {
      super(props);
      this.product_id=0;
      this.state = {
        isLoading: false,
        flag:0,
        guestinfo: {
            user_id: '',
            email: '',
            new_password: '',
            confirm_password: '',
            //otp: '',
          },
          eventinfo: {
            old_password: '',
            new_password:'',
            confirm_password:'',
            email: '',
          },
          removeinfo:{
            message: '',
            status: '',
          },
          country:[],
          city:[],
          shipping_cityshipping:[],
          shipping_countrystate:[],
          showPassword: false,
      }
      this.handleSubmit = this.handleSubmit.bind(this);
      //this.handleResendOtp = this.handleResendOtp.bind(this);
    //   this.handleDayChange = this.handleDayChange.bind(this);
    //   this.handleToDayChange = this.handleToDayChange.bind(this);
      this.validator = new SimpleReactValidator();
      this.billing_type = "1";
  }

//   handleDayChange(day) { alert(day);
//     var utcDate = day.toLocaleDateString();
//     $('#birth_date').val(utcDate);
//     this.state.guestinfo.birth_date_old = utcDate;
    
//     this.setState({ selectedDay: day });
//   }

//   handleToDayChange(day) { //alert(day);
//     var utcDate = day.toLocaleDateString();
//     $('#end_date').val(utcDate);
//     this.state.eventinfo.end_date = utcDate;
//     this.setState({ selectedDay: day });
//   }

  componentDidMount() {
      var message =  localStorage.getItem('success');
      var message1 = 'Email sent successfully, please check it.';
      if(message != '' && message != null ){
        // Use toast.success so the default ToastContainer shows a green success toast
        toast.success(''+message1);
        localStorage.removeItem('success');
      }
    // Prefer email+token from URL query params: /reset-password?email=...&token=...
    const query = new URLSearchParams(this.props.location.search || window.location.search);
  const emailParam = query.get('email');

    // Accept these possible reset link formats:
    // 1) /reset-password?email=...&token=...  (preferred)
    // 2) /reset-password/<token>              (path-based token)
    // 3) /reset-password?token=...            (token-only)

    let token = null;
    let email = null;

    // helper to extract token/email from current location
    const tokenKeys = ['token', 't', 'reset_token', 'resetToken', 'reset'];
    const extractFromLocation = (loc) => {
      const qp = new URLSearchParams((loc && loc.search) || window.location.search || '');
      let tk = null;
      for (const k of tokenKeys) {
        if (qp.get(k)) { tk = qp.get(k); break; }
      }
      let em = qp.get('email') || null;

      // try pathname
      if (!tk) {
        const pathname = (loc && loc.pathname) || window.location.pathname;
        const parts = pathname.split('/').filter(Boolean);
        const idx = parts.indexOf('reset-password');
        if (idx !== -1 && parts.length > idx + 1) tk = parts[idx + 1];
      }

      // try hash
      if (!tk) {
        const hash = (loc && loc.hash) || window.location.hash || '';
        try {
          if (hash.includes('token=')) {
            const hashParams = new URLSearchParams(hash.replace('#', ''));
            for (const k of tokenKeys) {
              if (hashParams.get(k)) { tk = hashParams.get(k); break; }
            }
            if (!em) em = hashParams.get('email') || em;
          } else if (hash.includes('/reset-password')) {
            const hparts = hash.replace('#', '').split('/').filter(Boolean);
            const idxh = hparts.indexOf('reset-password');
            if (idxh !== -1 && hparts.length > idxh + 1) tk = hparts[idxh + 1];
          }
        } catch (err) { console.warn('Error parsing hash for token', err); }
      }

      return { token: tk, email: em };
    };

    // First try immediately
    let found = extractFromLocation(this.props.location);
    token = found.token;
    email = found.email || emailParam || null;

    // If not found in query, try pathname: /reset-password/<token>
    if (!token) {
      const pathname = (this.props.location && this.props.location.pathname) || window.location.pathname;
      const parts = pathname.split('/').filter(Boolean);
      const idx = parts.indexOf('reset-password');
      if (idx !== -1 && parts.length > idx + 1) {
        token = parts[idx + 1];
      }
    }

    // If still not found, check hash fragment (some email clients add tokens into hash)
    if (!token) {
      const hash = (this.props.location && this.props.location.hash) || window.location.hash || '';
      try {
        if (hash.includes('token=')) {
          const hashParams = new URLSearchParams(hash.replace('#', ''));
          for (const k of tokenKeys) {
            if (hashParams.get(k)) {
              token = hashParams.get(k);
              break;
            }
          }
        } else if (hash.includes('/reset-password')) {
          const hparts = hash.replace('#', '').split('/').filter(Boolean);
          const idxh = hparts.indexOf('reset-password');
          if (idxh !== -1 && hparts.length > idxh + 1) token = hparts[idxh + 1];
        }
      } catch (err) {
        console.warn('Error parsing hash for token', err);
      }
    }

    console.log('Resetpassword: initial parsed email=', email, ' token=', token);

    if (!token) {
      // Retry several times (router/location may update shortly after mount)
      let tries = 0;
      const maxTries = 7; // ~7 * 300ms = 2.1s
      const iv = setInterval(() => {
        tries += 1;
        const f = extractFromLocation(this.props.location);
        if (f.token) {
          clearInterval(iv);
          token = f.token;
          email = f.email || emailParam || email;
          console.log('Resetpassword: token found on retry:', token);
          this.setState(prev => ({
            eventinfo: { ...prev.eventinfo, email: email || prev.eventinfo.email },
            guestinfo: { ...prev.guestinfo, token: token }
          }));
          if (email) $('#email').val(email);
          return;
        }
        if (tries >= maxTries) {
          clearInterval(iv);
          console.warn('Resetpassword: no token found after retries, redirecting.');
          this.props.history.replace('/signin');
        }
      }, 300);
    } else {
      // token present immediately
      this.setState(prev => ({
        eventinfo: { ...prev.eventinfo, email: email || prev.eventinfo.email },
        guestinfo: { ...prev.guestinfo, token: token }
      }));
      if (email) $('#email').val(email);
    }
  }

  componentDidUpdate(prevProps) {
    // no-op (kept for future use)
  }

  handleSubmit(e) {
    e.preventDefault();
  // console.log('this.refs',$('#pform').serializeArray());

  const { new_password } = this.state.guestinfo;
    // console.log('password: ',new_password, confirm_password);

    const isPassword = /^(?!.*\s)(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/.test(new_password);

    if (this.validator.allValid() && isPassword) {
        const formData = {};
        for (const field in this.refs) {
        formData[field] = this.refs[field].value;
        }
        // console.log('-->', formData);
        // Require token when available in state (preferred URL flow)
        const token = this.state.guestinfo.token || null;
        if (!token) {
          // No token -> block reset
          toast('Invalid password reset request. Please use the link from your email.', { containerId: 'B', type: toast.TYPE.ERROR });
          return;
        }

        // Prepare data for our Node.js backend (include token when present)
        const resetData = {
          email: this.state.eventinfo.email,
          // otp: this.state.guestinfo.otp,
          new_password: this.state.guestinfo.new_password,
          confirm_password: this.state.guestinfo.confirm_password,
          token: token
        };

        console.log('Sending password reset to Node API:', resetData);

        fetch(`${myConstClass.PASSWORD_API}/reset-password`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'credentials': 'include'
          },
          body: JSON.stringify(resetData),
        })
        .then(response => {
          console.log('Password reset HTTP status:', response.status);
          console.log('Password reset HTTP ok:', response.ok);
          return response.json();
        })
        .then(response => {
          console.log('Password reset response:', response);
          console.log('Response status field:', response.status);
          console.log('Response success field:', response.success);
          
          // Check multiple possible success indicators
          const isSuccess = response.status === 'success' 
                         || response.status === 'true' 
                         || response.status === true
                         || response.success === 'true'
                         || response.success === true;
          
          console.log('Is success:', isSuccess);
          
          if (isSuccess) {
            var message = response.message || "Your password has been changed successfully.";
            localStorage.setItem('success', message);
            // Use toast.success to show green success toast
            toast.success(message, { containerId: 'B' });
            
            // Clear reset password email from localStorage only if present
            if (localStorage.getItem('reset_password_email')) {
              localStorage.removeItem('reset_password_email');
            }
            
            // Redirect to login page after 2 seconds
            setTimeout(() => this.props.history.replace('/signin'), 2000);
          } else {
            var errorMessage = response.message || response.error || 'Password reset failed';
            toast(errorMessage, {containerId: 'B', type: toast.TYPE.ERROR});
          }
        })  
        .catch(err => {
          console.error('Password reset error:', err);
          toast('Network error. Please try again.', {containerId: 'B', type: toast.TYPE.ERROR});
        })
        }
    else{
      if (!isPassword) {
        toast.error("Invalid password format. Password must be at least 8 characters long, contain at least one letter, one digit, and no spaces")
      } else {
      toast('Please fill all required fields.', {containerId: 'B',type: toast.TYPE.ERROR})
      }
     //alert('here');
     this.validator.showMessages();
     console.log('validations'+this.validator.showMessages());
     e.preventDefault();
    // toast('Please fill all required fields.', {containerId: 'B',type: toast.TYPE.ERROR})
    }
  }

  // handleResendOtp() {
  //   const email = localStorage.getItem("reset_password_email");
  //   const emailArr = [{ name: "email", value: email }];
  //   // console.log('email: ',emailArr);
  //   this.setState({ isLoading: true });

  //   fetch(myConstClass.BASE_URL+`users/forgotPassword/`, {
  //     method: "POST",
  //     body: JSON.stringify(emailArr)
  //   })
  //   .then((res) => res.json())
  //   .then((res) => {
  //     this.setState({ isLoading: false });
  //     // console.log('res: ',res)
  //     toast.success(res.message);
  //   })
  //   .catch((error) => console.log('error: ',error))
  // }

  render() {
      
  const { eventinfo, guestinfo } = this.state  
    const { t } = this.props;
  return (
    
    <div className="App">
         <div>
        {/* <button onClick={this.notify}>Notify !</button> */}
          <ToastContainer />
        </div>
    <NewHeader />
    <div class="container-fluid">
   
        <div class="row" style={{marginTop:'10px'}}>
            <div class="col-lg-12 ">
                <div class="row mt-5 m-xl-0 mt-lg-0 mt-md-4 mt-sm-5">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb bg-white mb-0">
                            <li class="breadcrumb-item">
                            <Link   to="/">{t('home.home')}</Link>
                              </li>
                            {/* <li class="breadcrumb-item"><a href="#">{t('home.My Account')}</a></li> */}
                            <li class="breadcrumb-item active" aria-current="page">{t('home.Reset Password')}</li>
                        </ol>
                    </nav>
                </div>
                <div class="row">
                    <div class="col">
                        <h4>{t('home.Reset Password')}</h4>
                        <p><span class="color-red">* {t('home.Mandatory Fields')}</span></p>
                    </div>
                </div>
            </div>

            <div class="col col-lg-10 ">
                {/* <form> */}
                <Form action="" id="pform" onSubmit={this.handleSubmit}  method="post" encType="multipart/form-data" className="form-horizontal">

                <div class="row" style={{marginTop:'-10px',display:'none'}}>
                        <div class="form-group col col-md-4">
                            <label class="color-black font-weight-bolder">{t('home.Registered Email ID')}<span class="color-red">*</span></label>
                            <input value={eventinfo.email}    type="hidden" id="email" name="email" class="form-control" />
                        </div>
                </div>

                {/* <div class="row" style={{marginTop:'-10px'}}>
                        <div class="form-group col col-md-4">
                            <label class="color-black font-weight-bolder">{t('home.Existing Password')}<span class="color-red">*</span></label>
                            
                            <input value={guestinfo.old_password}  onChange={e => {this.setState({ guestinfo: {...guestinfo, old_password:e.target.value}})}} onBlur={() => this.validator.showMessageFor('old_password')} type="text" id="old_password" name="old_password" class="form-control" placeholder={t('home.Enter your password')} />
                            {this.validator.message('old_password', this.state.guestinfo.old_password, 'required')}
                        </div>
                    </div> */}

                    <div class="row" style={{marginTop:'-10px'}}>
                        {/* <div class="form-group col col-md-4">
                            <label class="color-black font-weight-bolder">{t('home.OTP')}<span class="color-red">*</span></label>
                            {/* <input onBlur={() => this.validator.showMessageFor('first_name')} type="text" class="form-control" id="first_name" name="first_name"  placeholder={t('home.Enter First Name')} /> */}
                            {/* <input value={guestinfo.otp}  onChange={e => {this.setState({ guestinfo: {...guestinfo, otp:e.target.value}})}} onBlur={() => this.validator.showMessageFor('otp')} type="text" id="new_password" name="otp" class="form-control" placeholder={t('home.Enter your OTP')} />
                            {this.validator.message('otp', this.state.guestinfo.otp, 'required')}
                        </div>  */}
                    </div>

                    <div class="row" style={{marginTop:'-10px'}}>
                        <div class="form-group col col-md-4">
                            <label class="color-black font-weight-bolder">{t('home.New Password')}<span class="color-red">*</span></label>
                            {/* <input onBlur={() => this.validator.showMessageFor('first_name')} type="text" class="form-control" id="first_name" name="first_name"  placeholder={t('home.Enter First Name')} /> */}
                            {/* <div className='position-absol'></div> */}
                            <input 
                              value={guestinfo.new_password}
                              onChange={e => {
                                const val = e.target.value.replace(" ", "");
                                this.setState({ guestinfo: {...guestinfo, new_password: val }})
                              }}
                              onBlur={() => this.validator.showMessageFor('new_password')} type="password" id="new_password" name="new_password" class="form-control" placeholder={t('home.Enter your password')}
                              onCopy={(e) => e.preventDefault()}
                              onPaste={(e) => e.preventDefault()}
                            />
                            {/* <button
                                type="button"
                                class="btn btn-link position-absolute"
                                style={{
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  padding: "0",
                                  border: "none",
                                  cursor: "pointer",
                                  color: "#9d0b0e",
                                }}
                                onClick={() =>
                                  this.setState({
                                    showPassword: !this.state.showPassword,
                                  })
                                }
                                tabIndex="-1"
                              >
                                {this.state.showPassword ? (
                                  <i class="fas fa-eye-slash"></i>
                                ) : (
                                  <i class="fas fa-eye"></i>
                                )}
                              </button> */}

                            {this.validator.message('new_password', this.state.guestinfo.new_password, 'required|min:8')}
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group col col-md-4">
                            <label class="color-black font-weight-bolder">{t('home.Confirm New Password')}<span class="color-red">*</span></label>
                            {/* <input onBlur={() => this.validator.showMessageFor('first_name')} type="text" class="form-control" id="first_name" name="first_name"  placeholder={t('home.Enter First Name')} /> */}
                            <input
                              value={guestinfo.confirm_password}
                              onChange={e => {
                                const val = e.target.value.replace(" ", "");
                                this.setState({ guestinfo: {...guestinfo, confirm_password: val }})
                              }}
                              onBlur={() => this.validator.showMessageFor('confirm_password')} type="password" id="confirm_password" name="confirm_password" class="form-control" placeholder={t('home.Enter your password')}
                              onCopy={(e) => e.preventDefault()}
                              onPaste={(e) => e.preventDefault()}
                           />
                            {this.validator.message('confirm_password', this.state.guestinfo.confirm_password, 'required|min:8')}
                        </div>
                    </div>
                   
                    <div class="row">
                        <div class="form-group col col-md-3" style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <button class="btn btn-brown">{t('home.Save')}</button>
                            {/* {this.state.isLoading ? <img id="loader" name="loader" src={myConstClass.IMAGE_URL+'loader.gif'} class="img-fluid" /> :
                            <span class="btn btn-brown" onClick={this.handleResendOtp} style={{ cursor: "pointer" }}>{t('home.Resend OTP')}</span> } */}
                            <Link class="btn btn-light" to="/">{t('home.Cancel')}</Link>
                        </div>
                    </div>
                  </Form>
            </div>
        </div>
    </div>
    <Footer />
    </div>
  );
}
}

Resetpassword.propTypes = {
    t: PropTypes.func.isRequired,
  };
export default translate(Resetpassword);
